var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRocket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 29,
    height: 42,
    viewBox: "0 0 29 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "wb6wn9byea",
    d: "M0.467 0.481L5.117 0.481 5.117 8.1 0.467 8.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "l5naem3rec",
    d: "M0.521 0.61L4.233 0.61 4.233 4.188 0.521 4.188z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#70C494",
    d: "M21.24 31.009l-2.092-5.918c.494-1.409.838-2.887.838-4.27 0-5.709-3.5-11.965-6.26-12.895-.086-.029-.182-.029-.27 0-2.758.93-6.258 7.186-6.258 12.894 0 1.384.345 2.862.84 4.27L5.944 31.01c-.056.157-.018.331.099.448l2.132 2.153c.082.084.19.127.3.127.088 0 .174-.027.249-.08l2.719-1.962.097.14c.079.113.209.18.346.18h3.41c.138 0 .267-.067.347-.18l.097-.14 2.719 1.962c.075.054.161.08.247.08.11 0 .22-.043.302-.126l2.131-2.153c.116-.118.156-.292.1-.449m-7.648-17.037c1.623 0 2.944 1.334 2.944 2.974 0 1.639-1.32 2.972-2.944 2.972-1.623 0-2.944-1.333-2.944-2.972 0-1.64 1.321-2.974 2.944-2.974"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B3F2A3",
    d: "M15.71 16.945c0 1.182-.948 2.14-2.118 2.14s-2.118-.958-2.118-2.14c0-1.181.948-2.14 2.118-2.14s2.119.959 2.119 2.14"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.8 32.516)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "4ex44abs1b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#wb6wn9byea"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#B3F2A3",
    d: "M2.792.48S.467 1.51.467 3.279C.467 6.087 2.792 8.1 2.792 8.1s2.325-2.013 2.325-4.822C5.117 1.51 2.792.481 2.792.481",
    mask: "url(#4ex44abs1b)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#B3F2A3",
    d: "M3.474 3.454c-.737.39-1.446.677-1.595.441-.149-.236.444-.794 1.126-1.32C2.75 1.508 3.402.435 4.46.178c.591-.144 1.216-.003 1.69.38.763-.402 1.509-.715 1.66-.47.153.244-.407.758-1.069 1.27.41 1.018-.076 2.178-1.084 2.591-.76.312-1.632.115-2.188-.494h.005zM6.375.766c.08.087.15.182.212.284l.03.054c.332-.24.637-.516.907-.824-.402.116-.788.279-1.152.486h.003zm-3.08 2.461c0-.017-.026-.031-.037-.051-.06-.1-.113-.203-.158-.31-.343.245-.654.531-.929.853.393-.12.769-.285 1.123-.492z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(23.4 3.716)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "wqd14dl45d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l5naem3rec"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#B3F2A3",
    d: "M4.18 2.15l-.701.69c-.045.041-.065.102-.054.162l.166.974c.017.1-.05.193-.148.21-.039.006-.08 0-.114-.019l-.866-.457c-.053-.029-.116-.029-.17 0l-.874.457c-.088.047-.197.013-.243-.076-.02-.035-.025-.075-.02-.115l.167-.974c.008-.06-.011-.12-.054-.162l-.694-.69c-.072-.07-.072-.186-.002-.258.028-.029.064-.047.103-.052l.968-.142c.058-.009.11-.046.135-.1L2.213.71c.045-.09.155-.128.245-.08.034.016.063.045.08.08l.431.887c.027.054.079.09.138.1l.968.142c.099.012.169.103.156.203-.005.04-.023.078-.052.106",
    mask: "url(#wqd14dl45d)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#B3F2A3",
    d: "M2.302 15.013l-.441.435c-.028.025-.04.063-.034.101l.105.613c.01.063-.032.122-.094.133-.024.003-.05 0-.07-.012l-.546-.288c-.034-.018-.073-.018-.106 0l-.551.288c-.055.029-.124.007-.153-.049-.012-.021-.016-.047-.012-.072l.104-.613c.006-.037-.007-.075-.033-.101l-.437-.435c-.044-.044-.045-.117-.001-.162.017-.018.04-.03.065-.033l.609-.09c.037-.005.068-.028.085-.062l.272-.558c.03-.057.098-.08.155-.05.022.01.04.028.05.05l.271.558c.017.034.05.057.088.063l.608.089c.062.008.106.065.098.127-.003.027-.014.05-.032.068M25.382 23.36c0-.628.504-1.136 1.125-1.136s1.125.508 1.125 1.137c0 .628-.504 1.136-1.125 1.136s-1.125-.508-1.125-1.136m1.125-.285c0 .158.126.285.281.285.156 0 .282-.127.282-.285 0-.156-.126-.284-.282-.284-.155 0-.28.128-.28.284"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/rocket.472d09a47a3f31fe42c32bf28e2d1dea.svg";
export { ForwardRef as ReactComponent };